import { default as angular } from "angular";
import uiRouter from "@uirouter/angularjs/lib-esm";

import { moduleName as recordsModuleName } from "../../records";
import { routeConfig } from "./routes";
import {
  vsName as MachineDetailConfigurationsComponentName,
  machineDetailConfigurationsComponentOptions,
  machineDetailConfigurationsComponentConfig,
} from "./views/machines/detail/configurations";
import {
  vsComponentName as MachineDetailConfigurationsDecommissionComponentName,
  MachineDetailConfigurationsDecommissionComponentOptions,
} from "./views/machines/detail/configurations/decommission";
import {
  vsComponentName as MachineDetailConfigurationsWarehouseComponentName,
  MachineDetailConfigurationsWarehouseComponentOptions,
} from "./views/machines/detail/configurations/warehouse";
import {
  vsComponentName as MachineDetailConfigurationsMoveComponentName,
  MachineDetailConfigurationsMoveComponentOptions,
} from "./views/machines/detail/configurations/move";
import {
  vsName as machineDetailPartsComponentName,
  machineDetailPartsComponentOptions,
  machineDetailPartsComponentConfig,
} from "./views/machines/detail/parts";
import {
  vsName as slotTrakServerAdapterName,
  SlotTrakServerAdapter,
} from "./slotTrakServerAdapter";

import { configSelectMachineFormlyType } from "./ui-formly/types/selectMachine/config";

import {
  vsComponentName as MachinesDecommissionComponentName,
  MachinesDecommissionViewComponentOptions,
} from "./views/machines/decommission";

// import {
//   vsComponentName as MachinesChangeComponentName,
//   MachinesChangeViewComponentOptions,
// } from "./views/machines/detail/changeDetails";

import {
  vsComponentName as MachinesWarehouseComponentName,
  MachinesWarehouseViewComponentOptions,
} from "./views/machines/warehouse";

import {
  vsComponentName as MachinesMoveComponentName,
  MachinesMoveViewComponentOptions,
} from "./views/machines/move";
import {
  vsComponentName as MachinesSoftwareUpgradeComponentName,
  MachinesSoftwareUpgradeViewComponentOptions,
} from "./views/machinesSoftware/SoftwareUpgrade";

import { vsModuleName as machinesConfigModuleName } from "./config/module";
import { vsModuleName as machinesComponentModuleName } from "./components/module";
import {
  attachUploadButtonOpenerDirective,
  vsName as attachUploadButtonOpenerDirectiveName,
} from "./views/machines/fileUploadOpener";
import {
  machineDetailProgressiveComponentConfig,
  vsComponentName as machineDetailProgressiveComponentName,
  MachineDetailProgressiveConfigurationComponentOptions,
} from "./views/machines/detail/progressiveConfiguration";
import {
  MachineDetailProgressiveConfigurationGameInfoComponentOptions,
  vsComponentName as MachineDetailProgressiveConfigurationGameInfoComponentName,
} from "./views/machines/detail/progressiveConfiguration/gameConfigurationProgressiveInformation/component";

import {
  CloneAndConversionService,
  vsName as CloneAndConversionServiceName,
} from "./services/cloneAndConversionService";
import {
  MachineExportService,
  vsServiceName as machineExportServiceName,
} from "./services/machineExportService";

export const vsName = "SlotTrak.Machines";

angular
  .module(vsName, [
    uiRouter,
    recordsModuleName,
    machinesComponentModuleName,
    machinesConfigModuleName,
  ])
  .config(routeConfig)
  .config(machineDetailConfigurationsComponentConfig)
  .config(machineDetailPartsComponentConfig)
  .config(machineDetailProgressiveComponentConfig)
  .config(configSelectMachineFormlyType)
  .service(slotTrakServerAdapterName, SlotTrakServerAdapter)
  .service(CloneAndConversionServiceName, CloneAndConversionService)
  .service(machineExportServiceName, MachineExportService)
  .directive(
    attachUploadButtonOpenerDirectiveName,
    attachUploadButtonOpenerDirective
  )
  .component(
    MachinesDecommissionComponentName,
    MachinesDecommissionViewComponentOptions
  )
  // .component(MachinesChangeComponentName, MachinesChangeViewComponentOptions)
  .component(
    MachinesWarehouseComponentName,
    MachinesWarehouseViewComponentOptions
  )
  .component(MachinesMoveComponentName, MachinesMoveViewComponentOptions)
  .component(
    MachinesSoftwareUpgradeComponentName,
    MachinesSoftwareUpgradeViewComponentOptions
  )
  .component(
    MachineDetailConfigurationsComponentName,
    machineDetailConfigurationsComponentOptions
  )
  .component(
    MachineDetailConfigurationsDecommissionComponentName,
    MachineDetailConfigurationsDecommissionComponentOptions
  )
  .component(
    MachineDetailConfigurationsWarehouseComponentName,
    MachineDetailConfigurationsWarehouseComponentOptions
  )
  .component(
    MachineDetailConfigurationsMoveComponentName,
    MachineDetailConfigurationsMoveComponentOptions
  )
  .component(
    machineDetailPartsComponentName,
    machineDetailPartsComponentOptions
  )
  .component(
    machineDetailProgressiveComponentName,
    MachineDetailProgressiveConfigurationComponentOptions
  )
  .component(
    MachineDetailProgressiveConfigurationGameInfoComponentName,
    MachineDetailProgressiveConfigurationGameInfoComponentOptions
  );

export default vsName;
